import * as Yup from 'yup';

export const getManageCustomCategoriesSchema = () => {
  return Yup.object().shape({
    name: Yup.string().required('Name is required'),
  });
};
